<template>
    <div class="satisfy-chart">
        <div class="overview-title">
            <span class="overview-title-text">{{ likeRatePrint }}</span>
        </div>
        <ECharts class="v-echarts" :options="options" autoresize />
    </div>
</template>

<script>
import ECharts from "vue-echarts";
import "echarts/lib/chart/line";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/legend";

export default {
    components: {
        ECharts
    },
    props: ["data"],
    data() {
        return {
            options: {}
        }
    },
    computed: {
        satisfactionTrend() {
            return this.getStorePorp("satisfactionTrend");
        },
        likeRatePrint() {
            return this.$t("zhiji.likedisplay.likeRatePrint"); 
        },
        feedbackRatePrint() {
            return this.$t("zhiji.likedisplay.feedbackRatePrint"); 
        },
        fabulousStepReason() {
            return this.$t("zhiji.likedisplay.fabulousStepReason"); 
        },
    },
    watch: {
        satisfactionTrend(data) {
            this.options = this.getOptions(data);
        }
    },
    methods: {
        getStorePorp(propName) {
            return this.$store.state.zhiji.likeDisplaySatis[propName];
        },
        getOptions(data) {
            return {
                color: ["#3FBDFF", "#FF886E"],
                legend: {
                    data: [
                        {
                            name: this.likeRatePrint, // 满意率
                            icon: "circle"
                        },
                        {
                            name: this.feedbackRatePrint, // 参评率
                            icon: "circle"
                        },
                    ],
                    left: 0,
                    itemGap: 20
                },
                tooltip: {
                    trigger: "axis",
                    textStyle: {
                        align: "left"
                    }
                },
                grid: {
                    left: "40",
                    right: "60",
                    bottom: "20",
                    containLabel: true
                },
                toolbox: {
                    feature: {
                        saveAsImage: {
                            show: false
                        }
                    }
                },
                xAxis: {
                    type: "category",
                    boundaryGap: false,
                    axisLine: {
                        lineStyle: {
                            color: "#B2BBDF"
                        }
                    },
                    axisLabel: {
                        color: "#41475e",
                        padding: [8, 0, 0, 0]
                    },
                    data: data.xAxisData
                },
                yAxis: {
                    type: "value",
                    axisLine: {
                        show: false,
                        symbol: "none"
                    },
                    axisTick: {
                        show: false
                    },
                    splitLine: {
                        show: true,
                        lineStyle: {
                            type: "dashed",
                            color: "#ECF1F7"
                        }
                    },
                },
                series: this.getSeries(data)
            };
        },
        getSeries(datas) {
            const lines = [
                {
                    name: this.likeRatePrint,
                    color: "#3FBDFF",
                    id: "likeRatePrint",
                },
                {
                    name: this.feedbackRatePrint,
                    color: "#FF886E",
                    id: "feedbackRatePrint"
                }
            ];

            return lines.map(function(line) {
                return {
                    name: line.name,
                    type: "line",
                    smooth: true,
                    itemStyle: {
                        normal: {
                            lineStyle: {
                                color: line.color
                            }
                        }
                    },
                    data: datas && datas[line.id] ? datas[line.id] : []
                };
            });
        }
    }
}
</script>

<style lang="less" scoped>
.satisfy-chart {
    box-sizing: border-box;
    padding: 16px 24px 6px;
    border-radius: 6px;
    background: #fff;
    border: 1px solid #d8e4f0;
    margin-top: 16px;

    .overview-title {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-pack: justify;
        -ms-flex-pack: justify;
        justify-content: space-between;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        padding-bottom: 8px;
        border-bottom: 1px solid #d8e4f0;
        margin-bottom: 10px;
    
        .overview-title-text {
            font-size: 14px;
            font-weight: bold;
            color: #41475e;
        }
    }
}
</style>